import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import styles from './Hero.module.css';
import { site } from '../content/site.js';
import { useClock } from '../hooks/useClock.js';

export default function Hero() {
  const clock = useClock(site.tz);
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -40]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.5]);
  const letter = useTransform(scrollYProgress, [0, 1], ['-0.04em', '-0.055em']);

  const lineTransition = (delay) => ({
    hidden: { y: '105%' },
    show: { y: '0%', transition: { duration: 0.9, delay, ease: [0.2, 0.8, 0.2, 1] } },
  });

  return (
    <header className={styles.hero} ref={ref}>
      <motion.h1
        className={styles.title}
        style={{ y, opacity, letterSpacing: letter }}
        initial="hidden"
        animate="show"
      >
        <span className={styles.line}>
          <motion.span variants={lineTransition(0.12)}>{site.hero.firstName}</motion.span>
        </span>
        <span className={styles.line}>
          <motion.span variants={lineTransition(0.22)}>
            {site.hero.lastName}
            <span className={styles.accent}>.</span>
          </motion.span>
        </span>
      </motion.h1>

      <div className={styles.meta}>
        {site.hero.meta.map((row) => (
          <div key={row.k} className={styles.metaRow}>
            <span>{row.k}</span>
            <span>
              {row.href ? (
                <a href={row.href} target="_blank" rel="noopener noreferrer">
                  {row.v}<span className="sr-only"> (opens in new tab)</span>
                </a>
              ) : row.v}
            </span>
          </div>
        ))}
        <div className={styles.metaRow}>
          <span>Local time</span>
          <span>{clock}</span>
        </div>
      </div>

      <div className={styles.sub}>
        <div>{site.hero.tag}</div>
        <div className={styles.subEnd}>Scroll ↓ &nbsp; or pick a section from the top menu</div>
      </div>
    </header>
  );
}
